import React, { useEffect, useState } from "react";
import { Container, Modal, Nav, Navbar, Offcanvas, OverlayTrigger, Popover, Accordion } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { AiOutlineMenu } from "react-icons/ai";
import { FaEye, FaEyeSlash, FaTimes } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { useMediaQuery } from 'react-responsive';
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { DESIGNER_MODE, GLOBAL_BUCKET, HEADER_MENU_DATA, TENANT_BUCKET, TENANT_NAME, WALLET_MENU_DATA, GAME_MENU_DATA } from '../../common/constants';
import { useMiddletier } from "../../common/middletier";
import { APP_STORE_ACTION, useStoreDispatch, useStoreState } from '../../common/storeContext';
import Announcement from '../announcement/template_01';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { LiveChatWidget } from '@livechat/widget-react';
import Loading from '../../components/Loading';
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { FaChevronDown } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";

import "./template_01.css";


const HeaderMenu = (props) => {
  const appState = useStoreState()
  const location = useLocation();
  const getLocation = location.hash ? location.hash?.substring(1) : '';
  const { name, icon, url, navIconToggle, menuIconPosition, selectedIcon, mobileShow, mallCategory } = props;

  const { t } = useTranslation();

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  return (
    <>
      {(!mobileShow && !isDesktopOrLaptop) ? <></> :
        (name === 'back_to_website') ?
          (<NavLink to={`https://${appState.domain}`}>

            <div className={`header_menu_content`} >
              {navIconToggle &&
                <div style={{ '--menu-icon': `url(${`${icon}`})`, '--active-menu-icon': `url(${`${selectedIcon}`})` }} className={`header_menu_icon`} ></div>
              }
              <div className={`  header_text ${!navIconToggle ? 'm-0' : ''}`} style={{ margin: menuIconPosition === 'vertical' ? '0.25rem 0 0 0' : '0 0 0 .35rem' }} >{t('website')}</div>
            </div>

          </NavLink>) : (<NavLink to={`${url}`}>
            {({ isActive }) => (
              <div className={`header_menu_content ${isActive && 'color_active active'}`} >
                {navIconToggle &&
                  <div style={{ '--menu-icon': `url(${`${icon}`})`, '--active-menu-icon': `url(${`${selectedIcon}`})` }} className={`header_menu_icon`} ></div>
                }
                <div className={`  header_text ${!navIconToggle ? 'm-0' : ''}`} style={{ margin: menuIconPosition === 'vertical' ? '0.25rem 0 0 0' : '0 0 0 .35rem' }} >{t('' + name + '')}</div>
                {(isDesktopOrLaptop && name === 'shop') && (<IoIosArrowDown className="arrow_icon" />)}
              </div>
            )}
          </NavLink>)
      }

      {(isDesktopOrLaptop && mallCategory?.length > 0 && (name === 'shop')) ?
        <div className="dropdown_content">
          <div className="dropdown_content_container">
            <div className="dropdown_content_wrap">
              <NavLink to={`shop`}  >
                <li>
                  <div>{t('all')}</div>
                </li>
              </NavLink>
              {
                mallCategory?.map((item, index) => {
                  return (
                    <NavLink to={`${url}#${item.code}`} key={index} >
                      <li key={item.code} className={getLocation === item.code && 'active'}>
                        <div>{t(`MALL_CATEGORY_${item.code}`)}</div>
                      </li>
                    </NavLink>
                  );
                })
              }
            </div>
          </div>
        </div>
        : <></>
      }

    </>
  );
};

const Header = (props) => {
  const appDispatch = useStoreDispatch()
  const appState = useStoreState()
  const navigate = useNavigate();
  const { query, mutation, queries } = useMiddletier()
  const { getValues, setValue, reset } = useForm();
  const { navIconDesktopToggle, navIconMobileToggle, desktopToggle, mobileToggle, dropdownImageSize, annLogoToggle, annHeaderToggle, headerMenuPosition, dropdownGameProviderNameToggle, sidebarToggle, enableDropdownHoverImage, menuInNewRow } = props
  const [announcementShow, setAnnouncementShow] = useState(true);
  const [mallCategory, setMallCategory] = useState({});

  const [loginMultipleShow, setLoginMultipleShow] = useState(false);
  const [language, setLanguage] = useState([]);
  const [languageShow, setLanguageShow] = useState(false);
  const [livechatID, setLiveChatID] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();

  const [visitorId, SetVisitorId] = useState()

  const location = useLocation();
  const isProfilePage = location.pathname === '/my-profile';


  const [gameProviders, setGameProviders] = useState([]);
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  const [sideBarShow, setSideBarShow] = useState(false);

  const menuIconPosition = ""

  const onChangeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("current_language", language);
  }


  const onSubmitLogin = (formData) => {
    const values = getValues();
    const method = 'loginByMember';

    let params = [
      { code: 'username', graphqlType: 'String', required: true, value: values.username },
      { code: 'password', graphqlType: 'String', required: true, value: values.password },
      { code: 'fingerprint', graphqlType: 'String', required: false, value: visitorId },
    ]


    if (values.force) {
      params.push({ code: 'force', graphqlType: 'Boolean', required: false, value: values.force })
    }

    mutation([{
      method,
      params,
      attributes: []
    }])
      .then(({ data }) => {
        // console.log(data[method])
        setValue('force', false)
        appDispatch({ type: APP_STORE_ACTION.LOGIN, payload: { ...data[method] } })
        reset()
      })
      .catch((error) => {
        console.log('error: ', error)
        if (error.toString().includes("multiple devices")) {
          setLoginMultipleShow(true)
        } else {
          appDispatch({
            type: APP_STORE_ACTION.SHOW_ALERT,
            payload: { description: error.message.toString(), typeAlert: 'error' }
          });
        }

      })
  }


  const onSubmitLogout = () => {
    mutation([
      {
        method: 'logout',
        params: [],
        attributes: []
      }
    ])
      .then(({ data }) => {
        appDispatch({ type: APP_STORE_ACTION.LOGOUT })
        if (window.LC_API) {
          window.LC_API.set_customer_name("");
        }
        navigate('/')
      })
      .catch((error) => {
        console.error('error: ', error)
        appDispatch({ type: APP_STORE_ACTION.LOGOUT })
        navigate('/')
      })
  }

  const formatAmount = (amount, decimalPoint) => {
    const factor = Math.pow(10, 0);
    const truncatedAmount = Math.floor(amount * factor) / factor;
    const formattedAmount = truncatedAmount.toLocaleString(appState.currencyFormat?.locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formattedAmount;
  }

  useEffect(() => {
    const getVisitorId = async () => {
      const fp = await FingerprintJS.load();
      const retVal = await fp.get();
      // console.log('retVal: ', retVal)
      SetVisitorId(retVal.visitorId);
    };

    getVisitorId();
  }, [])

  useEffect(() => {
    if (appState.loggedIn && appState.user?.username) {

      queries([
        {
          index: 'currency',
          method: 'currency',
          params: [
            { code: 'code', graphqlType: 'String', required: true, value: appState.user?.currency ?? appState.currency },
          ],
          attributes: ['code', 'locale', 'conversion_factor', 'prefix', 'postfix', 'min_deposit_amount', 'max_deposit_amount', 'default_deposit_amounts', 'min_transfer_amount', 'max_transfer_amount', 'decimal_point']

        },
        {
          index: 'inboxes',
          method: 'inboxes',
          params: [
            { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { recipient: appState.user.username } } }
          ],
          attributes: ['id', 'recipient', 'subject', 'message', 'update_ctr', 'status', 'created_at']

        }]).then(({ data }) => {



          const getCurrency = {
            ...data['currency'],
            default_deposit_amounts: JSON.parse(data['currency']?.default_deposit_amounts),
          };

          appDispatch({ type: APP_STORE_ACTION.SET_CURRENCY_FORMAT, payload: getCurrency })

          const getUnreadNotiCount = data['inboxes'].filter(item => item.status === 'UNREAD').length;

          appDispatch({ type: APP_STORE_ACTION.SET_UNREAD_NOTI, payload: getUnreadNotiCount })

        }).catch((error) => {
          console.log('error: ', error)
          if (error?.networkError?.statusCode === 401) {
            appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
          } else {
            appDispatch({
              type: APP_STORE_ACTION.SHOW_ALERT,
              payload: { description: error.message.toString(), typeAlert: 'error' }
            });
          }
        })

    }

  }, [appState.user, queries, appDispatch, navigate, appState.loggedIn, appState.currency]);

  // GET LANGUAGE
  useEffect(() => {
    const method = 'getLanguage'

    query({
      method,
      params: [
        { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE' } } },
      ],
      attributes: ['code', 'name']

    }).then(({ data }) => {

      setLanguage(data[method]);

    }).catch((error) => {
      console.log('error: ', error)
    })

  }, [query]);


  useEffect(() => {
    query(
      {
        method: 'getSocialMedia',
        params: [],
        attributes: []
      }
    )
      .then(({ data }) => {
        // console.log('data live chat: ', data['getSocialMedia'])
        let getLiveChat = data['getSocialMedia'].find(e => e.code === 'LIVECHAT');
        if (getLiveChat) {
          let getLiveChatValue = JSON.parse(getLiveChat.value);
          setLiveChatID(getLiveChatValue.license_id !== "" ? getLiveChatValue.license_id : "")
        } else {
          setLiveChatID("")
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }, [query])

  useEffect(() => {
    const showChat = () => {
      if (window.LC_API) {
        window.LC_API.open_chat_window();
      }
    };

    window.addEventListener('openChat', showChat);

    // Clean up the effect
    return () => window.removeEventListener('openChat', showChat);
  }, [appState.user?.username]);


  // IF LOCATION CHANGE
  useEffect(() => {

    // CHECK SIDEBAR
    setSideBarShow(false)

    // CHECK ANNOUCEMENT
    setAnnouncementShow(true)

  }, [location, mutation])

  useEffect(() => {
    const getLastLanguage = localStorage.getItem('current_language');
    if (getLastLanguage !== '') {
      i18n.changeLanguage(getLastLanguage)
    }

  }, [i18n])


  useEffect(() => {
    query(

      {
        method: 'getMallProductCategories',
        params: [
          { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { status: 'ACTIVE' } ,order: [['index', 'ASC']] } },
        ],
        attributes: ['code', 'name']

      },
    )
      .then(({ data }) => {
        setMallCategory(data['getMallProductCategories'])
      })
      .catch((error) => {
        console.error(error)
      })
  }, [query])

  const checkLogin = (event) => {
    if (!appState.loggedIn) {
      event.preventDefault();
      return appDispatch({
        type: APP_STORE_ACTION.SHOW_ALERT,
        payload: { description: t('error_login_continue'), typeAlert: 'error' }
      });
    }

  }


  if ((desktopToggle || mobileToggle) === true) {
    return (
      <>

        <header id="header_01" className={`section ${isDesktopOrLaptop ? "header_d" : "header_m"} ${desktopToggle ? "" : "d-lg-none"} ${mobileToggle ? "" : "d-none d-lg-block"} ${appState.loggedIn ? 'header_afterLogin' : 'header_beforeLogin'} ${DESIGNER_MODE && ('designerMode')}  ${mobileToggle ? "" : "d-none d-lg-block"} ${menuInNewRow ? 'header_newRowMenu' : ''} ${appState.enableLoyalty ? 'headerEnableLoyalty' : ''}`}>
          {/* <div className="testMode">{darkMode ? 'dark mode' : 'light mode'} dark green,light red</div> */}
          {["lg"].map((expand) => (
            <Navbar key={expand} expand={expand} className="color_primary header_topBar">
              <Container className="header_topBar_container">
                <div className="header_topBar_toolbar">
                  {sidebarToggle && (<Navbar.Toggle aria-controls={`header_menu_expand_${expand}`} onClick={() => setSideBarShow(true)}>
                    <AiOutlineMenu />
                  </Navbar.Toggle>)}

                  <Link to="/" className={`header_logo ${(!isDesktopOrLaptop && !sidebarToggle) && 'noSideBar'}`}>
                    <img src={`${TENANT_BUCKET}/icon/header_mall_logo.gif`} alt="Logo" />
                    {/* <img src={`https://storage.googleapis.com/demo-images.flexgaming.xyz/testing/header_logo_${darkMode ? 'dark' : 'light'}.gif`} alt="Logo" /> */}
                  </Link>
                </div>
                {/* ----------  Header Top Bar (Mobile) Start ----------  */}
                {!isDesktopOrLaptop &&
                  <div className="header_topBar_btn">
                    {appState.loggedIn ?
                      <>
                        {/* ----------  After Login Start ----------  */}

                        {/* ----------  After Login End ----------  */}
                      </> :
                      <>
                        {/* ----------  Before Login Start (Mobile) ----------  */}
                        <Link to="/login"><button className="color_button font_button header_btnLogin" >{t('login')}</button></Link>
                        {/* ---------- Before Login End ----------  */}
                      </>}

                    {language.length > 0 && (
                      <div id="header_language" onClick={() => setLanguageShow(true)}>
                        <img src={`${GLOBAL_BUCKET}/language/` + i18n.resolvedLanguage + `.png`} alt="language flag" />
                      </div>
                    )}
                    <Link to="/my-profile" className="header_user ms-2" onClick={(event) => checkLogin(event)}>
                      <img src={`${TENANT_BUCKET}/icon/header_user.png`} alt="" />
                      {/* <AiFillExclamationCircle /> */}
                    </Link>
                    <Link to="/shopping_cart" className="header_noti ms-2">
                      <img src={`${TENANT_BUCKET}/icon/header_cart.png`} alt="" />
                      {appState.totalCartCount > 0 && (
                        <span className="noti_dot">{appState.totalCartCount}</span>
                      )}
                    </Link>
                  </div>}
                {/* ----------  Header Top Bar (Mobile) End ----------  */}
                <Navbar.Offcanvas
                  id={`header_menu_expand_${expand}`}
                  className={!isDesktopOrLaptop && `header_sideBar`}
                  aria-labelledby={`header_menu_Label_expand_${expand}`}
                  placement="end"
                  show={sideBarShow}
                  onHide={() => setSideBarShow(false)}
                >
                  <Offcanvas.Header className=" header_sideBar_topBar color_primary">
                    <Offcanvas.Title id={`header_sideBar_Label_expand_${expand}`}>
                      <div className="header_sideBar_logo">
                        <img src={`${TENANT_BUCKET}/icon/header_mall_logo.gif`} alt="Logo" />
                      </div>
                    </Offcanvas.Title>
                    <button className="btn-close" aria-label="Close" onClick={() => setSideBarShow(false)}>
                      {/* <FaTimes /> */}
                    </button>
                  </Offcanvas.Header>
                  <Offcanvas.Body className=" header_sideBar_body">
                    {/* ----------  Header Top Bar (Desktop) Start ----------  */}
                    <Nav className="header_topBar_wrap">
                      <div className="d-none d-lg-block w-100">
                        <div className="header_navigation_section">
                          {/* ----------  Header Menu (Desktop) Start ----------  */}
                          {!menuInNewRow && (< div className="header_menu">
                            <Container className="header_menu_container" style={{ justifyContent: `${headerMenuPosition ?? 'start'}` }}>
                              {appState.menu.map((item, index) => {
                                item = HEADER_MENU_DATA[item] ?? ""
                                return (
                                  <div className="header_menu_page" key={index} style={{ minWidth: menuIconPosition === 'vertical' ? '6rem' : '' }}>

                                    {((!navIconDesktopToggle && index < 6) || (navIconDesktopToggle && index < 5)) ?
                                      <HeaderMenu
                                        name={item.name}
                                        icon={item.icon}
                                        selectedIcon={item.selectedIcon}
                                        url={item.url}
                                        navIconToggle={navIconDesktopToggle}
                                        menuIconPosition={menuIconPosition}
                                        mallCategory={mallCategory}
                                      />
                                      : <></>}
                                  </div>
                                )
                              })
                              }

                              {((!navIconDesktopToggle && appState.menu.length > 6) || (navIconDesktopToggle && appState.menu.length > 5)) &&
                                <div className="more_menu">
                                  <div className="header_menu_page">
                                    <div className="header_menu_content false">
                                      {navIconDesktopToggle && <div style={{ '--menu-icon': `url(${`${TENANT_BUCKET}/icon/menu_more.png`})`, '--active-menu-icon': `url(${`${TENANT_BUCKET}/icon/menu_more_active.png`})` }} className={`header_menu_icon`} ></div>}
                                      <div className={`header_text ${!navIconDesktopToggle && ('m-0')} `} style={{ margin: menuIconPosition === 'vertical' ? '0.25rem 0 0 0' : '0 0 0 .35rem' }} >
                                        {t('more')}
                                      </div>
                                    </div>

                                    <div className="dropdown_more_content">
                                      <div className="container dropdown_more_content_container">
                                        <div className="dropdown_more_content_wrap">
                                          {appState.menu.map((item, index) => {
                                            item = HEADER_MENU_DATA[item] ?? ""
                                            if ((!navIconDesktopToggle && index >= 6) || (navIconDesktopToggle && index >= 5)) {
                                              return (

                                                <HeaderMenu
                                                  name={item.name}
                                                  icon={item.icon}
                                                  selectedIcon={item.selectedIcon}
                                                  url={item.url}
                                                  navIconToggle={navIconDesktopToggle}
                                                  menuIconPosition={menuIconPosition}
                                                  dropdownMore={true}
                                                />
                                              );
                                            }
                                            return null
                                          })}

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }


                            </Container>
                          </div>)}


                          {/* ----------  Header Menu (Desktop) End ----------  */}

                          <div className="header_info_section">
                            {appState.loggedIn ?
                              <>
                                {/* ----------  After Login Start ----------  */}
                                <div className="header_top_row">

                                </div>
                                <div className="header_bottom_row">
                                  <div className="header_banking_info">
                                    <div className="header_balance">
                                      <div className="header_balance_amount">{formatAmount(appState.user?.reward_points ?? 0, appState.currencyFormat.decimal_point)}</div>
                                      <div className="header_balance_currency">{t('point')}</div>

                                    </div>
                                  </div>
                                  <Link to="/"><button className="font_button color_button header_btnLogout" onClick={onSubmitLogout}> {t("logout")}</button></Link>
                                  <div className="language_header">
                                    {language.length > 0 && (
                                      <>
                                        <div id="dropdown-languagemenu">
                                          <img src={`${GLOBAL_BUCKET}/language/` + i18n.resolvedLanguage + `.png`} alt="language flag" />
                                          <FiChevronDown />
                                        </div>
                                        <div className="language_dropdown">
                                          {language.length > 0 && (language?.map((items) => (
                                            <div key={items.code} style={{ fontWeight: i18n.resolvedLanguage === items.code ? 'bold' : 'normal' }} className="font_h5 header_menu_content dropdown-item header_menu_dropdownItem " type="submit" onClick={() => {
                                              onChangeLanguage(items.code);
                                            }}>
                                              <img src={`${GLOBAL_BUCKET}/language/` + items.code + `.png`} alt="language flag" className="me-2" />
                                              {items.name}
                                            </div>
                                          )))}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <OverlayTrigger
                                    key={'user_info_bottom'}
                                    placement={'bottom'}
                                    overlay={
                                      <Popover>
                                        <Popover.Body className="icon_name">
                                          {t(`my_account`)}
                                        </Popover.Body>
                                      </Popover>
                                    }
                                  >

                                    <Link to="/my_account/user_info" className="header_top_icon">
                                      <img
                                        src={`${TENANT_BUCKET}/icon/header_user.png`}
                                        alt=""
                                      />
                                    </Link>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    key={'shopping_cart_bottom'}
                                    placement={'bottom'}
                                    overlay={
                                      <Popover>
                                        <Popover.Body className="icon_name">
                                          {t(`shopping_cart`)}
                                        </Popover.Body>
                                      </Popover>
                                    }
                                  >
                                    <div className="header_noti header_top_icon">
                                      <Link to="/shopping_cart">
                                        <img src={`${TENANT_BUCKET}/icon/header_cart.png`} alt="" />
                                        {appState.totalCartCount > 0 && (
                                          <span className="noti_dot">{appState.totalCartCount}</span>
                                        )}
                                      </Link>
                                    </div>
                                  </OverlayTrigger>
                                </div>
                                {/* ----------  After Login End ----------  */}

                              </>
                              : <>
                                {/* ----------  Before Login Start ----------  */}
                                <div className="header_bottom_row">
                                  <Link to="/login"> <button className="font_button color_button header_btnLogin"> {t('login')} </button></Link>
                                  {/* <Link to="/register"><button className="font_button color_button header_btnRegister">{t('join_now')}</button></Link> */}
                                  {language.length > 0 && (
                                    <div className="language_header">
                                      <div id="dropdown-languagemenu">
                                        <img src={`${GLOBAL_BUCKET}/language/` + i18n.resolvedLanguage + `.png`} alt="language flag" />
                                        <FiChevronDown />
                                      </div>
                                      <div className="language_dropdown">
                                        {language.length > 0 && (language?.map((items) => (
                                          <div key={items.code} style={{ fontWeight: i18n.resolvedLanguage === items.code ? 'bold' : 'normal' }} className="font_h5 header_menu_content dropdown-item header_menu_dropdownItem " type="submit" onClick={() => {
                                            onChangeLanguage(items.code);
                                          }}>
                                            <img src={`${GLOBAL_BUCKET}/language/` + items.code + `.png`} alt="language flag" className="me-2" />
                                            {items.name}
                                          </div>
                                        )))}
                                      </div>
                                    </div>

                                  )}
                                  ︙
                                  <OverlayTrigger
                                    key={'user_info_bottom'}
                                    placement={'bottom'}
                                    overlay={
                                      <Popover>
                                        <Popover.Body className="icon_name">
                                          {t(`my_account`)}
                                        </Popover.Body>
                                      </Popover>
                                    }
                                  >

                                    <Link to="/my_account/user_info" className="header_top_icon header_user" onClick={(event) => checkLogin(event)}>
                                      <img
                                        src={`${TENANT_BUCKET}/icon/header_user.png`}
                                        alt=""
                                      />
                                    </Link>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    key={'shopping_cart_bottom'}
                                    placement={'bottom'}
                                    overlay={
                                      <Popover>
                                        <Popover.Body className="icon_name">
                                          {t(`shopping_cart`)}
                                        </Popover.Body>
                                      </Popover>
                                    }
                                  >
                                    <div className="header_noti header_top_icon">
                                      <Link to="/shopping_cart">
                                        <img src={`${TENANT_BUCKET}/icon/header_cart.png`} alt="" />
                                        {appState.totalCartCount > 0 && (
                                          <span className="noti_dot">{appState.totalCartCount}</span>
                                        )}
                                      </Link>
                                    </div>
                                  </OverlayTrigger>
                                </div>
                                {/* ----------  Before Login End ----------  */}</>}
                          </div>

                        </div>
                      </div>
                      {/* ----------  Header Top Bar (Desktop) End ----------  */}

                      {/* ----------  Header SideBar - Menu (Mobile) Start ----------  */}
                      <div className="d-lg-none">
                        <div className="header_sideBar_menu ">
                          {
                            appState.menu.map((item, index) => {
                              item = HEADER_MENU_DATA[item] ?? ""

                              // console.log('getFilterData',getFilterData)
                              return (
                                <div key={index}>
                                  <HeaderMenu
                                    name={item.name}
                                    icon={item.icon_m}
                                    selectedIcon={item.selectedIcon_m}
                                    url={item.url}
                                    navIconToggle={navIconMobileToggle}
                                    menuIconPosition={menuIconPosition}
                                    mobileShow={item.mobileShow}
                                  />
                                </div>
                              )
                            })
                          }
                          {!isDesktopOrLaptop &&
                            <>
                             
                              {
                                appState.loggedIn &&
                                <div className="header_menu_page">
                                  <Link className="header_menu_content" onClick={onSubmitLogout}>
                                    {navIconMobileToggle &&
                                      <div style={{ '--menu-icon': `url(${`${TENANT_BUCKET}/icon/sideBar_menu_logout.png`})`, '--active-menu-icon': `url(${`${TENANT_BUCKET}/icon/sideBar_menu_logout_active.png`})` }} className={`header_menu_icon`} ></div>
                                    }
                                    <div className=" header_text">{t('logout')}</div>
                                  </Link>

                                </div>
                              }
                            </>}
                        </div>
                      </div>
                      {/* ----------  Header SideBar - Menu (Mobile) End ----------  */}
                    </Nav>
                  </Offcanvas.Body>
                </Navbar.Offcanvas>
              </Container>
            </Navbar >
          ))}
          {/* ----------  BankingInfo Wallet (Mobile)  Start ----------  */}
        
          {
            (!isDesktopOrLaptop && appState.loggedIn && !isProfilePage) ?
              <div className="color_primary header_banking_info  ">
              <div className="container">
                  <div className="header_balance">
                  <img src={`${TENANT_BUCKET}/icon/point_icon.png`} alt="header icon" />
                    <div className="header_balance_currency">{TENANT_NAME} {t('point')}:</div>
                    <div className="header_balance_amount">
                      <span>{formatAmount(appState.user?.reward_points ?? 0, appState.currencyFormat.decimal_point)} { t('point')}</span>
                      {/* <span> </span> */}
                    </div>
                  </div>
                </div>
              </div> :
              <></>
          }
          {/* ----------  BankingInfo Wallet (Mobile)  End ----------  */}

          {/* ----------  New Row Header Menu (Desktop) Start ----------  */}
          {(isDesktopOrLaptop && menuInNewRow) && (< div className="header_menu">
            <Container className="header_menu_container" style={{ justifyContent: `${headerMenuPosition ?? 'start'}` }}>
              {appState.menu.map((item, index) => {
                item = HEADER_MENU_DATA[item] ?? ""
                return (
                  <div className="header_menu_page" key={index} style={{ minWidth: menuIconPosition === 'vertical' ? '6rem' : '' }}>
                    <HeaderMenu
                      name={item.name}
                      icon={item.icon}
                      selectedIcon={item.selectedIcon}
                      url={item.url}
                      navIconToggle={navIconDesktopToggle}
                      menuIconPosition={menuIconPosition}
                      mallCategory={mallCategory}
                    />
                  </div>
                )
              })
              }


            </Container>
          </div>)}


          {/* ----------  New Row Header Menu (Desktop) End ----------  */}
        </header>

        {
          livechatID && (< LiveChatWidget
            license={livechatID}
            // visibility="maximized"
            onChatLoaded={() => window.LC_API.minimize_chat_window()}
            // visibility={chatVisibility}
            customerName={typeof appState.user?.username !== 'undefined' ? appState.user?.username : 'Visitor'}
          />)
        }

        <Announcement show={announcementShow} onHide={() => (setAnnouncementShow(false))} annLogoToggle={annLogoToggle} annHeaderToggle={annHeaderToggle} />
        {isLoading && (<Loading />)}

        {
          !isDesktopOrLaptop && (<Modal show={languageShow} onHide={() => setLanguageShow(false)} centered id="languageModal">
            <Modal.Header closeButton>
              <Modal.Title>{t('language')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="language_content">
                {language.length > 0 && (language?.map((items) => (
                  <div key={items.code} style={{ fontWeight: i18n.resolvedLanguage === items.code ? 'bold' : 'normal' }} className="font_h3 header_menu_content dropdown-item header_menu_dropdownItem " type="submit" onClick={() => {

                    onChangeLanguage(items.code); setLanguageShow(false)
                  }}>
                    <img src={`${GLOBAL_BUCKET}/language/` + items.code + `.png`} alt="language flag" className="me-3" />
                    {items.name}
                  </div>
                )))}
              </div>
            </Modal.Body>
          </Modal>)
        }

        <Modal show={loginMultipleShow} onHide={() => setLoginMultipleShow(false)} centered id="multipleLoginDialog">
          <Modal.Header>
            <Modal.Title>{t('multiple_login_title')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{t('multiple_login_content')}</p>
          </Modal.Body>
          <Modal.Footer>
            <button className="cancel_button" onClick={() => setLoginMultipleShow(false)}>
              {t('cancel')}
            </button>
            <button className="confirm_button" onClick={() => {
              setValue('force', true)
              onSubmitLogin();
              setLoginMultipleShow(false);
            }}>
              {t('confirm')}
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  else {

  }
}

export default Header;
